import { forwardRef, HTMLAttributes, memo } from "react";
import classNames from "classnames";
import { CheckDefaultIcon, CheckLineIcon } from "../icons";

import styles from "./styles.module.scss";

export type CheckIconSize = "xs" | "sm" | "md" | "lg";
export type CheckIconColor = "primary" | "gray" | "success";
export type CheckIconType = "line" | "filled" | "default";

export type CheckIconProps = HTMLAttributes<HTMLDivElement> & {
  size?: CheckIconSize
  type?: CheckIconType
  color?: CheckIconColor
};

export const CheckIcon = memo(forwardRef<HTMLDivElement, CheckIconProps>((
  {
    size = "xs",
    type = "default",
    color = "primary",
    className,
    ...props
  }, ref) => {
  return (
    <div
      {...props}
      ref={ref}
      className={classNames(
        className,
        styles.root,
        styles[size],
        styles[type],
        styles[color],
      )}
    >
      {type === "default" ? <CheckDefaultIcon /> : <CheckLineIcon />}
    </div>
  );
}));